/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "読み込んでいます"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var jaJP = Object.assign(TranslationProviderComponent, {
  translations
});

export { jaJP as j };
//# sourceMappingURL=ja-JP-BRr2_oa0.js.map
